import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Divider, Tooltip, Typography, IconButton, SvgIcon, 
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Select, Menu, MenuItem, FormControl, InputLabel, TextField, CircularProgress, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import GlobalStyles from '../../../../styles/GlobalStyles.web';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { CustomTableTitle, ErrorStatusBar } from '../../../shared/components';
import { EMPTY_ROW_MSG, ERROR_404, ERROR_409, ERROR_500, ERROR_MSG, NO_PERMISSIONS_ERROR_MSG, formatDate } from '../../../shared/lib/Localization';
import { initQueryParams, replaceHistory, tableOptions, useQuery, } from '../../../shared/lib/TableQueryParams';
import { PaginatedResponse } from '../../../shared/models';
import { Toast, ToastError, enqueueSnackbar } from '../../../shared/components/Notifier';
import ClearIcon from '@material-ui/icons/Clear';
import { getCCRSErrorRecordList, saveRecordStatusComments } from '../../api';
import EditIcon from '@material-ui/icons/Edit';



export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
        padding: theme.spacing(1),
        marginBottom: 16,
  
    },
    containerCenter: {
      padding: theme.spacing(1, 1),
      textAlign: 'center'
    },
    subDivider: {
      margin: theme.spacing(1, 0),
    },
    pageTitle: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    dialogContent: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

    },
    select: {
        color: '#0a0a0a',
        marginRight: 4,
        '&:before': {
          borderColor: '#0a0a0a',
        },
        '&:after': {
          borderColor: '#0a0a0a',
        },
        maxWidth: '12rem',
        minWidth: '9rem',
    },
  }),
);



const CCRSErrorsScreen = (props: any) => {
  // console.log(props);
  const classes = useStyles({});
  const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [selectedReportType, setSelectedReportType] = useState('')
  const [selectedReportStatus, setSelectedReportStatus] = useState('')
  const [selectedRecord, setSelectedRecord] = useState<any>('')
  const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
  const [selectedBusinessId, setSelectedBusinessId] = useState(props?.userData?.selectedBusiness?.business_id);
  const tableRef = useRef<{ onQueryChange: any; }>();
  let locationQuery = useQuery(useLocation);
  const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogBoxOpen, setDialogBoxOpen] = useState(false);
  const [selectedBusinessName, setSelectedBusinessName] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState<any>(null);
  // console.log("user data");
  // console.log(props.userData);

  useEffect(() => {
    if (selectedReportStatus && selectedReportType) {
        handleRefresh();
    }
  }, [selectedReportStatus, selectedReportType])


  useEffect(() => {
    if (props.userData && props.userData.selectedBusiness) {
      const sbId = props.userData.selectedBusiness.business_id;
      setSelectedBusinessId(sbId);
      setSelectedBusinessName(props.userData.selectedBusiness.business_name);
      tableRef.current && tableRef.current.onQueryChange();


      const pageData = {
        page: 1,
        pageSize: 500,
        businessId: props?.userData?.selectedBusiness?.business_id
      }
            
    }
  }, [props?.userData?.selectedBusiness])

  
  const handleSelectReportChange = (event: any) => {
    setSelectedReportType(event.target.value);
  }
  const handleSelectReportStatusChange = (event: any) => {
    setSelectedReportStatus(event.target.value);
  }

  const handleDialogBoxCancel = () => {
    setDialogBoxOpen(false);
    setEditRowData(null);

  }

  const handleShowEditRecord = (rowData: any) => {
    setSelectedRecord(rowData);
    const currentValues = {...rowData};
    setEditRowData(currentValues);
    setDialogBoxOpen(true);
  }
  const handleChangeCommentsDetail = (e:any) => {
    console.log("Comments value - ", e.target.value);
    let currentValues = {}
    if (editRowData) {
      currentValues = {...editRowData}
    }
    currentValues['Comments'] = e.target.value;
    setEditRowData(currentValues);
  }

  
  const handleStatusChange = (e:any) => {
    console.log("Status value - ", e.target.value);
    let currentValues = {}
    if (editRowData) {
      currentValues = {...editRowData}
    }
    currentValues['UploadStatus'] = e.target.value;
    setEditRowData(currentValues);
  }

  const handleSave = () => {
    const sb = props.userData.selectedBusiness
    let payload = {
        "id": editRowData.id,
        "Comments": editRowData.Comments,
        "UploadStatus": editRowData.UploadStatus
    }

    saveRecordStatusComments(payload, selectedReportType, sb.business_id,)
    .catch(handleError) // handle network issues
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => {
        handleRefresh();
        setLoading(false);
        handleDialogBoxCancel();
    })
    .catch((err: any) => {
        setLoading(false);
    });

  }

  const handleRefresh =()=>{
    tableRef.current && tableRef.current.onQueryChange();
  }



  const renderFixRecordDialogBox = () => {
    return (
      <div>
        {
          <Dialog
            open={dialogBoxOpen}
            onClose={handleDialogBoxCancel}
            fullWidth={true}
            maxWidth="xs"
          >
            <DialogTitle style={{ color: GlobalStyles.primaryColor }}>Fix Record {editRowData && editRowData != null ? editRowData.ExternalIdentifier : ""}</DialogTitle>
            <DialogContent style={{ padding: "10px", }}>
              <div className={classes.dialogContent} >
                <FormControl variant="outlined" style={{ marginBottom: 15 }}>
                  <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
                  <Select
                    // label="Template"
                    labelId="demo-simple-select-outlined-label"
                    id={`upload-statuses`}
                    value={editRowData && editRowData != null ? editRowData.UploadStatus : null}
                    onChange={(e) => handleStatusChange(e)}
                    // variant="outlined"
                    style={{ width: '12rem' }}
                    label={`Status`}
                    fullWidth={true}
                    margin="dense"
                  >
                    <MenuItem value={"CCRS_ERRORED"}>CCRS Errored</MenuItem>
                    <MenuItem value={"TO_RESUBMIT"}>To Resubmit</MenuItem>
                    <MenuItem value={"SUCCESSFUL"}>Successful</MenuItem>
                    
                  </Select>
                </FormControl>
                <FormControl variant="outlined" style={{ marginBottom: 15 }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        size="medium"
                        multiline
                        // value={getCommentsValueForRow(rowData)}
                        value={editRowData && editRowData != null ? editRowData.Comments : ""}
                        onChange={(e)=>handleChangeCommentsDetail(e)}
                        label="Enter Comments"
                        type="text"
                        // style={{ width: '12rem' }}
                    />
                </FormControl>
                
                {
                  dialogLoading &&
                  <div style={{ textAlign: 'center', marginTop: 5 }}>
                    <CircularProgress />
                  </div>
                }
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogBoxCancel} color="primary" autoFocus>
                Cancel
              </Button>
              <Button onClick={() => handleSave()} style={{ color: "#ff1744" }} disabled={false} >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        }
      </div>
    )
  }

  return (
    <Paper className={classes.paper} >
        <div style={{ display: 'flex', width: '100%', flexDirection: "column", justifyContent: 'space-between', flexWrap: 'wrap', padding: 2 }}>

          <div style={{ alignSelf: 'flex-start', display: 'flex', alignItems: 'center' }}>
            <Typography style={{ paddingRight: 10, color: GlobalStyles.primaryColor }}>
              Choose a Report Type & Status:
            </Typography>
            <FormControl
              style={{}}>
              <Select
                labelId="select-label"
                id="select-task"
                value={selectedReportType}
                onChange={handleSelectReportChange}
                className={classes.select}
              >
                {/* <MenuItem value=''>None</MenuItem> */}
                <MenuItem value={"sale"}>Sale</MenuItem>
                <MenuItem value={"product"}>Product</MenuItem>
                <MenuItem value={"inventory"}>Inventory</MenuItem>
                <MenuItem value={"inventory_adjustment"} >Inventory Adjustment</MenuItem>
                <MenuItem value={"inventory_transfer"}>Inventory Transfer</MenuItem>
                <MenuItem value={"area"}>Area</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{}}>
              <Select
                labelId="select-status"
                id="select-status"
                value={selectedReportStatus}
                onChange={handleSelectReportStatusChange}
                className={classes.select}
              >
                <MenuItem value={"GENERATED"}>Generated</MenuItem>
                <MenuItem value={"UPLOADED"}>Uploaded</MenuItem>
                <MenuItem value={"CCRS_ERRORED"}>CCRS Errored</MenuItem>
                <MenuItem value={"TO_RESUBMIT"}>To Resubmit</MenuItem>
                <MenuItem value={"SUCCESSFUL"}>Successful</MenuItem>
              </Select>
            </FormControl>
            <Tooltip title="Clear task" placement="bottom">
              <IconButton onClick={() => {
                setSelectedReportType('');
                setSelectedReportStatus('');
                }} style={{ marginRight: 16 }}>
                <ClearIcon />
              </IconButton>
            </Tooltip>
            </div>
            <div>
            <ErrorStatusBar isVisible={isErrorStatusVisible} />
            {selectedReportType && selectedReportStatus && <div className="table-wrapper">
                <MaterialTable
                options={{
                    debounceInterval: 500,
                    ...tableOptions(tableQuery),
                    emptyRowsWhenPaging: false,
                    thirdSortClick: false,
                    draggable: false,
                    sorting: true
                }}
                tableRef={tableRef}
                localization={{
                    body: {
                    emptyDataSourceMessage: emptyDataSourceMessage
                    }
                }}
                onRowClick={(event, rowData) => {}}
                columns={[
                    {

                        title: 'Edit',
                        field: 'Edit',
                        editable: 'never',
                        render: rowData => {
                        return <IconButton onClick={() => handleShowEditRecord(rowData)} color="primary" autoFocus><EditIcon /></IconButton>;
                        }
                    },
                    {

                        title: 'External Identifier',
                        field: 'ExternalIdentifier',
                        editable: 'never',
                        render: rowData => {
                          if (rowData.ExternalIdentifier) {
                            return <Typography variant="subtitle2">{rowData.ExternalIdentifier}</Typography>;
                          }
                          return <Typography variant="subtitle2" ></Typography>;
                        }
                      },
                      {
                        title: 'Status',
                        field: 'UploadStatus',
                        editable: 'never',
                        render: rowData => {
                          if (rowData.UploadStatus) {
                            return <Typography variant="subtitle2">{rowData.UploadStatus}</Typography>;
                          }
                          return <Typography variant="subtitle2" ></Typography>;
                        }
                      },
                      {
                        title: 'Error',
                        field: 'CCRSError',
                        editable: 'never',
                        render: rowData => {
                          if (rowData.CCRSError) {
                            return <Typography variant="subtitle2">{rowData.CCRSError}</Typography>;
                          }
                          return <Typography variant="subtitle2" ></Typography>;
                        }
                      },
                ]}
                data={query =>
                    new Promise((resolve, reject) => {
                        if (!isLoading) {
                            // console.log('query', query);
                            const sb = props.userData.selectedBusiness;
                            if (sb && sb.business_id) {
                              replaceHistory(query, props.history);
                              let pageData = {
                                data: [] as any[],
                                totalCount: 0,
                                page: query.page
                              };
                              let orderBy = '';
                              if (query.orderBy) {
                                orderBy = query.orderBy.field as string;
                                orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                              }
                              setLoading(true);
          
                              
                              
                              getCCRSErrorRecordList(
                                sb.business_id,
                                selectedReportType,
                                selectedReportStatus,
                                query.page + 1,
                                query.pageSize,
                                query.search,
                                orderBy
                              )
                                .catch(handleError) // handle network issues
                                .then(checkStatus)
                                .then(parseJSON)
                                .then((data: any) => {
                                  setErrorStatusVisible(false);
                                  setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                                    // setFullData(data.results);
                                  pageData = {
                                    data: data.results,
                                    totalCount: data.count,
                                    page: query.page
                                  };
                                  setTableQuery({
                                    ...tableQuery,
                                    orderBy,
                                    totalCount: data.count,
                                    page: query.page,
                                    pageSize: query.pageSize
                                  });
                                  resolve(pageData);
                                  setLoading(false);
                                })
                                .catch((error: any) => {
                                  if (error) {
                                    if (error.status && error.status === 500) {
                                      setEmptyDataSourceMessage(ERROR_500);
                                      setErrorStatusVisible(false);
                                    } else if ((error.status === 403 || error.status === 401)
                                    ) {
                                      setEmptyDataSourceMessage(ERROR_MSG);
                                      setErrorStatusVisible(true);
                                    } else {
                                      setEmptyDataSourceMessage(ERROR_MSG);
                                      setErrorStatusVisible(false);
                                    }
                                  }
                                  setTableQuery({
                                    ...tableQuery,
                                    totalCount: 0,
                                    page: query.page,
                                    pageSize: query.pageSize
                                  });
                                  resolve(pageData);
                                });
          
                              }
                            // }
          
                          }
                    })
                }
                title={
                    <CustomTableTitle
                    // history={props.history}
                    title={'CCRS Records'}
                    icon={SVG_ICONS.template} />
                }
                actions={[
                    {
                    icon: 'refresh',
                    tooltip: 'Refresh Data',
                    isFreeAction: true,
                    onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                    },
                ]}
                />
            </div>}
            {renderFixRecordDialogBox()}
            </div>
        
        </div>
    </Paper>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.userLocalData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showToast: (toast: Toast) => dispatch(enqueueSnackbar(toast))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(CCRSErrorsScreen);